import { select } from 'redux-saga/effects';

// Our worker Saga that logins the user
export function* startupApp(api) {
  const { token } = yield select(state => state.auth);

  return api.setAuthorization(token);
}
